<template>
  <kst-print-table :data="items">
    <b-table-column
      v-slot="{ column, row }"
      field="DispatchID"
      :label="InvItemCatalog.DispatchID.PrintLabel"
    >
      <kst-value :field="column.field" :data="row" :catalog="InvItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-sku-large"
      field="SKU"
      :label="InvItemCatalog.SKU.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="InvItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-qty-print"
      field="RequestedQuantity"
      :label="InvItemCatalog.RequestedQuantity.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="InvItemCatalog">
        <kst-value field="Packaging" :data="row" :catalog="InvItemCatalog"/>
      </kst-value>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-price"
      field="SellPrice"
      :label="InvItemCatalog.SellPrice.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="InvItemCatalog"/>
    </b-table-column>

    <template v-if="details.SpecialPriceCount > 0">
      <b-table-column
        v-slot="{ column, row }"
        cell-class="ks-col-specialpricename"
        field="SpecialPriceID"
      >
        <template v-if="row.SpecialPriceID !== null">
          <kst-value :field="column.field" :data="row" :catalog="InvItemCatalog"/>
        </template>
      </b-table-column>
    </template>

    <b-table-column
      v-if="hasItemLevelDisc && hasDiscountedItem"
      v-slot="{ column, row }"
      cell-class="ks-col-disc-value"
      field="DiscPercent"
      label="Diskon"
    >
      <template v-if="row.DiscPercent > 0">
        <kst-value :field="column.field" :data="row" :catalog="InvItemCatalog"/>
      </template>
      <template v-else-if="row.DiscValue > 0">
        <kst-value field="DiscValue" :data="row" :catalog="InvItemCatalog"/>
      </template>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-subtotal"
      field="TotalAfterDisc"
      :label="InvItemCatalog.Price.Label"
    >
      <kst-value field="TotalAfterDisc" :data="getRowDisplay(row)" :catalog="InvItemCatalog"/>
    </b-table-column>
  </kst-print-table>
</template>

<script>
import AppModuleAttr from "../../../services/App/AppModuleAttr.js";
import InvItemCatalog from "../InvItemCatalog.js";

export default {
  props: {
    details: Object,
    items: Array
  },
  data: () => ({
    InvItemCatalog: InvItemCatalog
  }),
  computed: {
    hasItemLevelDisc() {
      return this.$kst.Access.hasModuleAttr(AppModuleAttr.ItemLevelDisc_Act_List);
    },
    // tampilkan kolom diskon hanya bila minimal satu baris item berdiskon
    hasDiscountedItem() {
      return Array.isArray(this.items) && this.items.some(
        (row) => (row.DiscPercent || 0) > 0 || (row.DiscValue || 0) > 0
      );
    }
  },
  methods: {
    // Sub Total per baris: pakai TotalAfterDisc jika tersimpan, fallback
    // Price (Qty x Harga) agar tidak kosong untuk baris tanpa diskon item
    // maupun dokumen lama yang belum menyimpan TotalAfterDisc.
    getRowDisplay(row) {
      const totalAfterDisc = row.TotalAfterDisc !== null &&
        row.TotalAfterDisc !== undefined ? row.TotalAfterDisc : null;
      const price = row.Price !== null && row.Price !== undefined
        ? row.Price : null;

      return {
        ...row,
        TotalAfterDisc: totalAfterDisc !== null
          ? totalAfterDisc
          : (price !== null ? price : (row.RequestedQuantity || 0) * (row.SellPrice || 0))
      };
    }
  }
}
</script>